import {
  amountUtils,
  notEmpty,
  type SourceReaderFunction,
} from '@festina-life/core'
import * as Yup from 'yup'

import type { translations } from '../../../../translations/translations'
import { type AnyFractionVFrame, isRangeVFrame } from './types'

export const percentageValidation = (
  frame: AnyFractionVFrame,
  translate: SourceReaderFunction<(typeof translations)['en-GB']>,
) => {
  let percentage = Yup.number()

  const [min, max] = isRangeVFrame(frame)
    ? [frame.min, frame.max]
    : [undefined, undefined]

  const minMaxMessage =
    notEmpty(min) && notEmpty(max)
      ? translate('validation.between', {
          max: amountUtils.formatPercentWithDecimals(max, 2),
          min: amountUtils.formatPercentWithDecimals(min, 2),
        })
      : undefined

  if (notEmpty(min)) {
    percentage = percentage.min(
      min,
      minMaxMessage ??
        translate('validation.min', {
          min: amountUtils.formatPercentWithDecimals(min, 2),
        }),
    )
  }

  if (notEmpty(max)) {
    percentage = percentage.max(
      max,
      minMaxMessage ??
        translate('validation.max', {
          max: amountUtils.formatPercentWithDecimals(max, 2),
        }),
    )
  }

  return percentage
}
